import React from 'react';

// Button component with Boss UX styling
const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  disabled = false,
  className = '',
  ...props 
}) => {
  const baseStyle = "inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    secondary: "bg-neutral-100 text-neutral-700 hover:bg-neutral-200 focus:ring-neutral-500",
    outline: "border border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-50 focus:ring-primary-500",
    danger: "bg-error-600 text-white hover:bg-error-700 focus:ring-error-500",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm rounded-sm",
    md: "px-4 py-2 text-sm rounded",
    lg: "px-6 py-3 text-base rounded-md",
  };

  return (
    <button
      className={`${baseStyle} ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

// Input component with Boss UX styling
const Input = ({ 
  label,
  error,
  className = '',
  ...props 
}) => {
  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-neutral-700">
          {label}
        </label>
      )}
      <input
        className={`
          block w-full rounded border-neutral-300 shadow-sm
          focus:border-primary-500 focus:ring-primary-500 sm:text-sm
          ${error ? 'border-error-500 focus:border-error-500 focus:ring-error-500' : ''}
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className="text-sm text-error-600">{error}</p>
      )}
    </div>
  );
};

// Card component with Boss UX styling
const Card = ({ 
  children, 
  className = '',
  ...props 
}) => {
  return (
    <div
      className={`bg-white shadow rounded-lg ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

// Alert component with Boss UX styling
const Alert = ({ 
  title,
  children,
  variant = 'info',
  className = '',
  ...props 
}) => {
  const variants = {
    info: "bg-primary-50 text-primary-700",
    success: "bg-success-50 text-success-700",
    warning: "bg-warning-50 text-warning-700",
    error: "bg-error-50 text-error-700",
  };

  return (
    <div className={`rounded-md p-4 ${variants[variant]} ${className}`} {...props}>
      <div className="flex">
        <div className="flex-1">
          {title && (
            <h3 className="text-sm font-medium mb-1">{title}</h3>
          )}
          <div className="text-sm">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

// Export all components as named exports
export {
  Button,
  Input,
  Card,
  Alert
};